import { formatDateTimeLabel } from "../../../shared/utils/dateTime";
import type {
  ChallengeStatus,
  ChallengeType,
} from "../../challenges/types/challengeAdmin";
import { challengeTypeLabel } from "../../challenges/utils/challengeLabels";
import { siteTexts } from "../../../shared/i18n/siteTexts";

type ChallengeRouteParams = {
  challengeName?: string;
  challengeStatus?: ChallengeStatus;
  challengeType?: ChallengeType;
  challengeParticipantsCount?: number;
  challengeScheduledAt?: string | null;
};

type AdminPageHeaderMetaParams = {
  challengeIdFromRoute?: number;
  challengeRouteParams?: ChallengeRouteParams;
  contentRouteMode?: boolean;
  isAdmin: boolean;
};

export function getAdminPageHeaderMeta({
  challengeIdFromRoute,
  challengeRouteParams,
  contentRouteMode,
  isAdmin,
}: AdminPageHeaderMetaParams) {
  const t = siteTexts.admin;
  const routeChallengeName = String(
    challengeRouteParams?.challengeName || "",
  ).trim();
  const routeChallengeStatus = challengeRouteParams?.challengeStatus;
  const routeChallengeType = challengeRouteParams?.challengeType;
  const routeStatusLabel =
    routeChallengeStatus === "pending"
      ? t.statuses.pending
      : routeChallengeStatus === "started"
        ? t.statuses.started
        : routeChallengeStatus === "finished"
          ? t.statuses.finished
          : "";
  const routeMetaBits = [
    routeStatusLabel,
    routeChallengeType ? challengeTypeLabel(routeChallengeType) : "",
    Number.isFinite(challengeRouteParams?.challengeParticipantsCount)
      ? `${challengeRouteParams?.challengeParticipantsCount} jogadores`
      : "",
    challengeRouteParams?.challengeScheduledAt
      ? formatDateTimeLabel(challengeRouteParams.challengeScheduledAt)
      : "",
  ].filter(Boolean);
  const pageTitle = challengeIdFromRoute
    ? routeChallengeName || `Desafio #${challengeIdFromRoute}`
    : contentRouteMode
      ? t.tabs.content
      : isAdmin
        ? t.pageTitle
        : t.pageTitleOrganizer;
  const pageSubtitle = challengeIdFromRoute
    ? routeMetaBits.length > 0
      ? routeMetaBits.join(" · ")
      : t.sidebar.selectedChallengeEdit
    : contentRouteMode
      ? t.sidebar.contentConfig
      : isAdmin
        ? t.pageSubtitle
        : t.pageSubtitleOrganizer;

  return {
    pageSubtitle,
    pageTitle,
  };
}
